import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import format from 'date-fns/format'
import { Query, Mutation } from 'react-apollo'
import { EVENTS_QUERY, UPDATE_EVENT_MUTATION } from 'graphql/queries'
import { Container, Header, Table, Button } from 'semantic-ui-react'

class Events extends Component {
  renderRow = ({ id, title, address, location, active, startTime }) => {
    return (
      <Table.Row key={id}>
        <Table.Cell>{title}</Table.Cell>
        <Table.Cell>{address ? address : location}</Table.Cell>
        <Table.Cell>{format(startTime, 'MM/DD/YY')}</Table.Cell>
        <Table.Cell>{String(active)}</Table.Cell>
        <Table.Cell>
          <div style={{ display: 'flex' }}>
            <Link to={`/events/edit/${id}`}>
              <Button primary>Edit</Button>
            </Link>
            <Mutation
              mutation={UPDATE_EVENT_MUTATION}
              refetchQueries={[
                { query: EVENTS_QUERY, variables: { limit: 1000, offset: 0 } },
              ]}
            >
              {(updateEvent, { loading }) => {
                return (
                  <Button
                    loading={loading}
                    primary
                    color="orange"
                    onClick={() => {
                      updateEvent({
                        variables: { id, input: { active: !active } },
                      })
                    }}
                  >
                    {active ? 'Unpublish' : 'Publish'}
                  </Button>
                )
              }}
            </Mutation>
          </div>
        </Table.Cell>
      </Table.Row>
    )
  }

  render() {
    return (
      <Container>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Header as="h1" content="Events" />
          <Link to="/events/new">
            <Button>New Event</Button>
          </Link>
        </div>

        <Query query={EVENTS_QUERY}>
          {({ data, loading, error }) => {
            if (loading) {
              return <div>loading...</div>
            }

            if (error) {
              return <div>An error occurred while fetching events</div>
            }

            return (
              <Table>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Title</Table.HeaderCell>
                    <Table.HeaderCell>Address/Location</Table.HeaderCell>
                    <Table.HeaderCell>Start Date</Table.HeaderCell>
                    <Table.HeaderCell>Active</Table.HeaderCell>
                    <Table.HeaderCell>Actions</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>{data.events.map(this.renderRow)}</Table.Body>
              </Table>
            )
          }}
        </Query>
      </Container>
    )
  }
}

export default Events
